// extracted by mini-css-extract-plugin
export default {"next":"OAuthButtons_next__SJqif"};